// extracted by mini-css-extract-plugin
export default {"bg":"HFEdcM","inlineContent":"tANF9k","pageWrapper":"ngRNGR"};